// src/pages/admin/LandingPagesAdmin.js
import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const DISENO_VACIO = { hero_title:'', hero_subtitle:'', hero_image:'', primary_color:'#2E7D32', secondary_color:'#F1F8E9', button_text:'COMPRAR AHORA', countdown_fecha:'' };
const EMPTY = {
  titulo:'', producto_id:'', activa:true,
  diseno: DISENO_VACIO,
  eco_badges: [],
  shipping_note:'',
  ingredientes: [],
  refill_activo: false, refill_texto:'',
  testimonios: [],
  faq: [],
  galeria: [],
  video_url:'', video_titulo:'',
  html_personalizado:'',
};

const fmtCOP = v => new Intl.NumberFormat('es-CO',{style:'currency',currency:'COP',minimumFractionDigits:0}).format(v||0);

function armarSecciones(form) {
  const secciones = [];
  if (form.ingredientes.filter(Boolean).length) {
    secciones.push({ type:'ingredients_and_benefits', title:'Ingredientes y Beneficios', items: form.ingredientes.filter(Boolean) });
  }
  if (form.refill_activo && form.refill_texto) {
    secciones.push({ type:'refill_info', title:'Sistema Refill Wawita ♻️', description: form.refill_texto });
  }
  if (form.testimonios.length) {
    secciones.push({ type:'testimonials', title:'Reseñas de la Comunidad Wawita', items: form.testimonios });
  }
  if (form.faq.length) {
    secciones.push({ type:'faq', title:'Preguntas Frecuentes', items: form.faq });
  }
  if (form.galeria.filter(Boolean).length) {
    secciones.push({ type:'gallery', items: form.galeria.filter(Boolean) });
  }
  if (form.video_url) {
    secciones.push({ type:'video', url: form.video_url, title: form.video_titulo });
  }
  if (form.html_personalizado) {
    secciones.push({ type:'html_block', html: form.html_personalizado });
  }
  return secciones;
}

function desarmarSecciones(secciones = []) {
  const get = (type) => secciones.find(s => s.type === type);
  return {
    ingredientes: get('ingredients_and_benefits')?.items || [],
    refill_activo: !!get('refill_info'),
    refill_texto: get('refill_info')?.description || '',
    testimonios: get('testimonials')?.items || [],
    faq: get('faq')?.items || [],
    galeria: get('gallery')?.items || [],
    video_url: get('video')?.url || '',
    video_titulo: get('video')?.title || '',
    html_personalizado: get('html_block')?.html || '',
  };
}

export default function LandingPagesAdmin() {
  const [landings, setLandings] = useState([]);
  const [productos, setProductos] = useState([]);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [metricas, setMetricas] = useState(null);
  const [subiendoImagen, setSubiendoImagen] = useState(false);
  const [subiendoGaleria, setSubiendoGaleria] = useState(false);
  const [subiendoVideo, setSubiendoVideo] = useState(false);
  const [subiendoAvatar, setSubiendoAvatar] = useState(null);

  const load = () => api.get('/landings').then(r => setLandings(r.data)).catch(()=>{});
  useEffect(() => {
    load();
    api.get('/productos?todos=1').then(r => setProductos(r.data)).catch(()=>{});
  }, []);

  const abrir = (l = null) => {
    setEditId(l?.id || null);
    if (l) {
      setForm({
        titulo: l.titulo, producto_id: l.producto_id, activa: !!l.activa,
        diseno: { ...DISENO_VACIO, ...JSON.parse(l.diseno || '{}') },
        eco_badges: JSON.parse(l.eco_badges || '[]'),
        shipping_note: l.shipping_note || '',
        ...desarmarSecciones(JSON.parse(l.secciones || '[]')),
      });
    } else {
      setForm(EMPTY);
    }
    setModal(true);
    setMetricas(null);
  };

  const guardar = async () => {
    if (!form.titulo || !form.producto_id) return toast.error('Titulo y producto son requeridos');
    setLoading(true);
    try {
      const payload = {
        titulo: form.titulo,
        producto_id: form.producto_id,
        activa: form.activa,
        diseno: JSON.stringify(form.diseno),
        eco_badges: JSON.stringify(form.eco_badges.filter(Boolean)),
        secciones: JSON.stringify(armarSecciones(form)),
        shipping_note: form.shipping_note,
      };
      if (editId) {
        await api.put('/landings/' + editId, payload);
        toast.success('Landing actualizada');
      } else {
        await api.post('/landings', payload);
        toast.success('Landing creada');
      }
      setModal(false);
      load();
    } catch(e) { toast.error(e.response?.data?.error || 'Error'); }
    finally { setLoading(false); }
  };

  const eliminar = async (id) => {
    if (!window.confirm('Eliminar esta landing page?')) return;
    try {
      await api.delete('/landings/' + id);
      toast.success('Landing eliminada');
      load();
    } catch(e) { toast.error('Error al eliminar'); }
  };

  const verMetricas = async (slug) => {
    try {
      const r = await api.get(`/landings/${slug}/metricas`);
      setMetricas(r.data);
    } catch(e) { toast.error('No se pudieron cargar las métricas'); }
  };

  // Helpers para editar arrays de la seccion
  const setD = (k, v) => setForm(f => ({ ...f, diseno: { ...f.diseno, [k]: v } }));

  const subirHeroImagen = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setSubiendoImagen(true);
    try {
      const fd = new FormData();
      fd.append('imagen', file);
      const r = await api.post('/uploads/imagen', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setD('hero_image', r.data.url);
      toast.success('Imagen subida');
    } catch(err) { toast.error('Error al subir la imagen'); }
    finally { setSubiendoImagen(false); e.target.value = ''; }
  };
  const subirGaleria = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setSubiendoGaleria(true);
    try {
      const fd = new FormData();
      files.slice(0, 5).forEach(f => fd.append('imagenes', f));
      const r = await api.post('/uploads/imagenes-multiples', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setForm(f => ({ ...f, galeria: [...f.galeria, ...r.data.imagenes.map(i => i.url)] }));
      toast.success('Imágenes subidas');
    } catch(err) { toast.error('Error al subir las imágenes'); }
    finally { setSubiendoGaleria(false); e.target.value = ''; }
  };
  const subirVideoArchivo = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setSubiendoVideo(true);
    try {
      const fd = new FormData();
      fd.append('video', file);
      const r = await api.post('/uploads/video', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setForm(f => ({ ...f, video_url: r.data.url }));
      toast.success('Video subido');
    } catch(err) { toast.error('Error al subir el video'); }
    finally { setSubiendoVideo(false); e.target.value = ''; }
  };
  const subirAvatarTestimonio = async (e, i) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setSubiendoAvatar(i);
    try {
      const fd = new FormData();
      fd.append('imagen', file);
      const r = await api.post('/uploads/imagen', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      updItem('testimonios', i, { avatar: r.data.url });
    } catch(err) { toast.error('Error al subir la foto'); }
    finally { setSubiendoAvatar(null); e.target.value = ''; }
  };
  const addItem = (key, empty) => setForm(f => ({ ...f, [key]: [...f[key], empty] }));
  const updItem = (key, i, patch) => setForm(f => ({ ...f, [key]: f[key].map((it, idx) => idx===i ? { ...it, ...patch } : it) }));
  const delItem = (key, i) => setForm(f => ({ ...f, [key]: f[key].filter((_, idx) => idx!==i) }));

  return (
    <div>
      <div style={{ background:"#fff", borderBottom:"1px solid var(--border)", padding:"14px 28px", position:"sticky", top:0, zIndex:10, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
        <h1 style={{ fontSize:18, fontWeight:900, color:"var(--forest)" }}>Landing Pages ({landings.length})</h1>
        <button className="btn btn-primary" style={{ background:"#9FBE6A", color:"#1C3A1E" }} onClick={() => abrir()}>+ Nueva landing</button>
      </div>

      <div style={{ padding:"24px 28px" }}>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(300px,1fr))", gap:16 }}>
          {landings.map(l => (
            <div key={l.id} className="card">
              <div className="card-body">
                <div style={{ display:"flex", gap:6, marginBottom:8, flexWrap:"wrap" }}>
                  {l.activa ? <span style={{ fontSize:11, padding:"2px 8px", borderRadius:20, background:"rgba(45,90,48,0.1)", color:"#2c5e2e", fontWeight:700 }}>Activa</span> : <span style={{ fontSize:11, padding:"2px 8px", borderRadius:20, background:"rgba(160,160,160,0.15)", color:"#666", fontWeight:700 }}>Inactiva</span>}
                </div>
                <h3 style={{ fontSize:15, fontWeight:700, color:"var(--forest)", marginBottom:4 }}>{l.titulo}</h3>
                <p style={{ fontSize:12, color:"var(--ink-faint)", marginBottom:4 }}>{l.producto_nombre} · {fmtCOP(l.producto_precio)}</p>
                <p style={{ fontSize:11, color:"var(--ink-faint)", marginBottom:12, fontFamily:"monospace" }}>wawita.co/landing/{l.slug}</p>
                <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                  <button onClick={() => abrir(l)} className="btn btn-outline btn-sm" style={{ flex:1 }}>Editar</button>
                  <button onClick={() => { navigator.clipboard.writeText('https://wawita.co/landing/' + l.slug); toast.success('URL copiada'); }} style={{ padding:"5px 12px", borderRadius:"var(--r-sm)", border:"1px solid rgba(28,58,30,0.2)", background:"#fff", color:"var(--forest)", fontWeight:700, fontSize:12, cursor:"pointer" }}>🔗</button>
                  <button onClick={() => eliminar(l.id)} style={{ padding:"5px 12px", borderRadius:"var(--r-sm)", border:"none", background:"#fcebeb", color:"#a32d2d", fontWeight:700, fontSize:12, cursor:"pointer" }}>🗑️</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {modal && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", zIndex:1000, display:"flex", alignItems:"flex-start", justifyContent:"center", padding:24, overflowY:"auto" }}>
          <div className="card" style={{ width:"100%", maxWidth:760, margin:"auto" }}>
            <div className="card-header">
              <span className="card-title">{editId ? "Editar landing page" : "Nueva landing page"}</span>
              <button onClick={() => setModal(false)} style={{ background:"none", border:"none", fontSize:20, cursor:"pointer" }}>✕</button>
            </div>
            <div className="card-body" style={{ display:"flex", flexDirection:"column", gap:14 }}>

              <div style={{ display:"grid", gridTemplateColumns:"2fr 1fr", gap:12 }}>
                <div className="form-group">
                  <label className="form-label">Titulo interno *</label>
                  <input className="form-input" value={form.titulo} onChange={e=>setForm(f=>({...f,titulo:e.target.value}))} placeholder="Landing Bloqueador Verano 2026" />
                </div>
                <div className="form-group">
                  <label style={{ display:"flex", alignItems:"center", gap:8, cursor:"pointer", fontSize:14, fontWeight:600, marginTop:22 }}>
                    <input type="checkbox" checked={form.activa} onChange={e=>setForm(f=>({...f,activa:e.target.checked}))} style={{ accentColor:"#9FBE6A" }} />
                    Activa
                  </label>
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Producto / Combo *</label>
                <select className="form-input" value={form.producto_id} onChange={e=>setForm(f=>({...f,producto_id:e.target.value}))}>
                  <option value="">Seleccionar producto</option>
                  {productos.map(p => <option key={p.id} value={p.id}>{p.nombre} — {fmtCOP(p.precio)}</option>)}
                </select>
              </div>

              {editId && (
                <div style={{ background:"var(--cream)", borderRadius:10, padding:14 }}>
                  <button className="btn btn-outline btn-sm" onClick={() => verMetricas(landings.find(l=>l.id===editId)?.slug)}>Ver métricas de campaña</button>
                  {metricas && (
                    <div style={{ display:"flex", gap:20, marginTop:12, fontSize:13 }}>
                      <div><strong>{metricas.vistas}</strong> vistas</div>
                      <div><strong>{metricas.clics}</strong> clics ({metricas.tasa_clic}%)</div>
                      <div><strong>{metricas.compras}</strong> compras ({metricas.tasa_conversion}%)</div>
                    </div>
                  )}
                </div>
              )}

              <h4 style={{ color:"var(--forest)", fontSize:14, margin:"6px 0 0" }}>Diseño del hero</h4>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
                <div className="form-group">
                  <label className="form-label">Título del hero</label>
                  <input className="form-input" value={form.diseno.hero_title} onChange={e=>setD('hero_title', e.target.value)} placeholder="¡Cuida tu piel y el planeta! 🌿" />
                </div>
                <div className="form-group">
                  <label className="form-label">Subtítulo / oferta</label>
                  <input className="form-input" value={form.diseno.hero_subtitle} onChange={e=>setD('hero_subtitle', e.target.value)} placeholder="20% OFF por tiempo limitado" />
                </div>
                <div className="form-group" style={{ gridColumn:"1/-1" }}>
                  <label className="form-label">Imagen del hero</label>
                  <div style={{ display:"flex", gap:10, alignItems:"center" }}>
                    <label className="btn btn-outline btn-sm" style={{ cursor: subiendoImagen ? "wait" : "pointer", opacity: subiendoImagen ? 0.6 : 1 }}>
                      {subiendoImagen ? "Subiendo..." : "📤 Subir imagen"}
                      <input type="file" accept="image/*" hidden disabled={subiendoImagen} onChange={subirHeroImagen} />
                    </label>
                    <span style={{ fontSize:12, color:"var(--ink-faint)" }}>o pega una URL abajo</span>
                  </div>
                  <input className="form-input" style={{ marginTop:8 }} value={form.diseno.hero_image} onChange={e=>setD('hero_image', e.target.value)} placeholder="https://res.cloudinary.com/..." />
                  {form.diseno.hero_image && (
                    <img src={form.diseno.hero_image} alt="" style={{ marginTop:8, width:"100%", maxHeight:200, objectFit:"contain", background:"var(--cream)", borderRadius:8 }} onError={e=>e.target.style.display="none"} onLoad={e=>e.target.style.display="block"} />
                  )}
                </div>
                <div className="form-group">
                  <label className="form-label">Color primario</label>
                  <input className="form-input" type="color" value={form.diseno.primary_color} onChange={e=>setD('primary_color', e.target.value)} />
                </div>
                <div className="form-group">
                  <label className="form-label">Color secundario</label>
                  <input className="form-input" type="color" value={form.diseno.secondary_color} onChange={e=>setD('secondary_color', e.target.value)} />
                </div>
                <div className="form-group">
                  <label className="form-label">Texto del botón</label>
                  <input className="form-input" value={form.diseno.button_text} onChange={e=>setD('button_text', e.target.value)} placeholder="COMPRAR AHORA CON DESCUENTO" />
                </div>
                <div className="form-group">
                  <label className="form-label">Fin de la oferta (countdown)</label>
                  <input className="form-input" type="datetime-local" value={form.diseno.countdown_fecha} onChange={e=>setD('countdown_fecha', e.target.value)} />
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Eco badges (uno por línea)</label>
                <textarea className="form-input" rows={3} value={form.eco_badges.join('\n')} onChange={e=>setForm(f=>({...f,eco_badges:e.target.value.split('\n')}))} placeholder={"Sin Plástico\n100% Natural\nCruelty Free"} />
              </div>

              <div className="form-group">
                <label className="form-label">Ingredientes y beneficios (uno por línea)</label>
                <textarea className="form-input" rows={3} value={form.ingredientes.join('\n')} onChange={e=>setForm(f=>({...f,ingredientes:e.target.value.split('\n')}))} placeholder={"Filtros minerales aptos para piel sensible\nEmpaque reciclable"} />
              </div>

              <div className="form-group">
                <label style={{ display:"flex", alignItems:"center", gap:8, cursor:"pointer", fontSize:14, fontWeight:600 }}>
                  <input type="checkbox" checked={form.refill_activo} onChange={e=>setForm(f=>({...f,refill_activo:e.target.checked}))} style={{ accentColor:"#9FBE6A" }} />
                  Mostrar banner de Sistema Refill
                </label>
                {form.refill_activo && (
                  <textarea className="form-input" rows={2} style={{ marginTop:8 }} value={form.refill_texto} onChange={e=>setForm(f=>({...f,refill_texto:e.target.value}))} placeholder="Recuerda que cuando te lo termines, puedes recargar el envase..." />
                )}
              </div>

              <div className="form-group">
                <label className="form-label">Reseñas destacadas</label>
                {form.testimonios.map((t, i) => (
                  <div key={i} style={{ display:"flex", gap:10, alignItems:"flex-start", marginBottom:10, background:"var(--cream)", borderRadius:10, padding:10 }}>
                    <label style={{ cursor: subiendoAvatar===i ? "wait" : "pointer", flexShrink:0 }}>
                      {t.avatar ? (
                        <img src={t.avatar} alt="" style={{ width:44, height:44, borderRadius:"50%", objectFit:"cover" }} />
                      ) : (
                        <div style={{ width:44, height:44, borderRadius:"50%", background:"#fff", border:"1.5px dashed rgba(28,58,30,0.25)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:16, color:"var(--ink-faint)" }}>
                          {subiendoAvatar===i ? "…" : "📷"}
                        </div>
                      )}
                      <input type="file" accept="image/*" hidden disabled={subiendoAvatar===i} onChange={e=>subirAvatarTestimonio(e,i)} />
                    </label>
                    <div style={{ flex:1, display:"grid", gridTemplateColumns:"1fr 2fr 60px", gap:8 }}>
                      <input className="form-input" placeholder="Nombre" value={t.name||''} onChange={e=>updItem('testimonios', i, {name:e.target.value})} />
                      <input className="form-input" placeholder="Comentario" value={t.comment||''} onChange={e=>updItem('testimonios', i, {comment:e.target.value})} />
                      <input className="form-input" type="number" min={1} max={5} placeholder="⭐" value={t.rating||5} onChange={e=>updItem('testimonios', i, {rating:+e.target.value})} />
                    </div>
                    <button onClick={()=>delItem('testimonios', i)} style={{ border:"none", background:"#fcebeb", color:"#a32d2d", borderRadius:8, cursor:"pointer", flexShrink:0, width:28, height:28 }}>✕</button>
                  </div>
                ))}
                <button className="btn btn-outline btn-sm" onClick={()=>addItem('testimonios', {name:'',comment:'',rating:5,avatar:''})}>+ Agregar reseña</button>
                <div style={{ fontSize:11.5, color:"var(--ink-faint)", marginTop:6 }}>La foto es opcional — sin ella se muestra la inicial del nombre.</div>
              </div>

              <div className="form-group">
                <label className="form-label">Preguntas frecuentes</label>
                {form.faq.map((f, i) => (
                  <div key={i} style={{ display:"grid", gridTemplateColumns:"1fr 1fr 32px", gap:8, marginBottom:8 }}>
                    <input className="form-input" placeholder="Pregunta" value={f.question||''} onChange={e=>updItem('faq', i, {question:e.target.value})} />
                    <input className="form-input" placeholder="Respuesta" value={f.answer||''} onChange={e=>updItem('faq', i, {answer:e.target.value})} />
                    <button onClick={()=>delItem('faq', i)} style={{ border:"none", background:"#fcebeb", color:"#a32d2d", borderRadius:8, cursor:"pointer" }}>✕</button>
                  </div>
                ))}
                <button className="btn btn-outline btn-sm" onClick={()=>addItem('faq', {question:'',answer:''})}>+ Agregar pregunta</button>
              </div>

              <h4 style={{ color:"var(--forest)", fontSize:14, margin:"6px 0 0" }}>Galería, video y bloques a medida</h4>

              <div className="form-group">
                <label className="form-label">Galería de fotos del producto</label>
                <div style={{ display:"flex", flexWrap:"wrap", gap:8, marginBottom:10 }}>
                  {form.galeria.map((url, i) => (
                    <div key={i} style={{ position:"relative", width:64, height:64, background:"var(--cream)", borderRadius:8, display:"flex", alignItems:"center", justifyContent:"center", overflow:"hidden" }}>
                      <img src={url} alt="" style={{ width:"100%", height:"100%", objectFit:"contain" }} />
                      <button onClick={()=>delItem('galeria', i)} style={{ position:"absolute", top:-6, right:-6, width:20, height:20, borderRadius:"50%", border:"none", background:"#a32d2d", color:"#fff", fontSize:11, cursor:"pointer", lineHeight:1 }}>✕</button>
                    </div>
                  ))}
                </div>
                <label className="btn btn-outline btn-sm" style={{ cursor: subiendoGaleria ? "wait" : "pointer", opacity: subiendoGaleria ? 0.6 : 1 }}>
                  {subiendoGaleria ? "Subiendo..." : "📤 Agregar fotos (hasta 5)"}
                  <input type="file" accept="image/*" multiple hidden disabled={subiendoGaleria} onChange={subirGaleria} />
                </label>
              </div>

              <div className="form-group">
                <label className="form-label">Video</label>
                <div style={{ display:"flex", gap:10, alignItems:"center", marginBottom:8 }}>
                  <label className="btn btn-outline btn-sm" style={{ cursor: subiendoVideo ? "wait" : "pointer", opacity: subiendoVideo ? 0.6 : 1 }}>
                    {subiendoVideo ? "Subiendo..." : "📤 Subir video"}
                    <input type="file" accept="video/*" hidden disabled={subiendoVideo} onChange={subirVideoArchivo} />
                  </label>
                  <span style={{ fontSize:12, color:"var(--ink-faint)" }}>o pega una URL de YouTube/Vimeo abajo</span>
                </div>
                <input className="form-input" style={{ marginBottom:8 }} value={form.video_url} onChange={e=>setForm(f=>({...f,video_url:e.target.value}))} placeholder="https://www.youtube.com/watch?v=..." />
                <input className="form-input" value={form.video_titulo} onChange={e=>setForm(f=>({...f,video_titulo:e.target.value}))} placeholder="Título opcional (ej: Cómo se aplica)" />
                {form.video_url && <div style={{ fontSize:11.5, color:"var(--sage-deep)", marginTop:6 }}>✓ Video listo: {form.video_url}</div>}
              </div>

              <div className="form-group">
                <label className="form-label">Bloque HTML personalizado</label>
                <div style={{ fontSize:12, color:"var(--terra)", marginBottom:8, background:"rgba(196,99,42,0.08)", padding:"8px 12px", borderRadius:8 }}>
                  ⚠️ Este contenido se inserta tal cual en la página pública. Solo pega HTML de una fuente de confianza.
                </div>
                <textarea className="form-input" rows={6} style={{ fontFamily:"monospace", fontSize:12 }} value={form.html_personalizado} onChange={e=>setForm(f=>({...f,html_personalizado:e.target.value}))} placeholder="<div>Tu HTML/CSS personalizado...</div>" />
              </div>

              <div className="form-group">
                <label className="form-label">Nota de envío</label>
                <input className="form-input" value={form.shipping_note} onChange={e=>setForm(f=>({...f,shipping_note:e.target.value}))} placeholder="Envíos gratis en Pasto por compras superiores a $50.000 COP." />
              </div>

              <div style={{ display:"flex", gap:10, marginTop:8 }}>
                <button className="btn btn-primary" style={{ flex:1, background:"#9FBE6A", color:"#1C3A1E" }} onClick={guardar} disabled={loading}>
                  {loading ? "Guardando..." : editId ? "Guardar cambios" : "Crear landing"}
                </button>
                <button className="btn btn-outline" onClick={() => setModal(false)}>Cancelar</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
